import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { userContext } from 'contexts/userContext';
import ButtonCustom from 'components/Common/ButtonCustom/ButtonCustom';
import styles from '../NewsletterPage.module.scss';
import { getUri } from 'services/generic';
import { gtmAfiEventLab } from 'services/gtm';

function NewsletterPage(): JSX.Element {
  const { t } = useTranslation(['newsletterPage']);
  const { pathname } = useLocation();
  const { gtmUserCookie } = useContext(userContext);

  return (
    <div className={styles.unsubscribe}>
      <div className={styles.header}>
        <h2>{t('LABEL_I_UNSUBSCRIBE')} -</h2>
        <span>{t('LABEL_SUBTITLE_3')}</span>
      </div>
      <div className={styles.unsubscribeActions}>
        <ButtonCustom
          label={t('LABEL_I_UNSUBSCRIBE')}
          color="grey"
          className={styles.unsubscribeButton}
          onClick={() => {
            gtmAfiEventLab(
              pathname,
              'afiEvent',
              'Newsletter',
              'Désabonnement',
              gtmUserCookie
            );
            window.location.href = getUri('/newsletter/subscriber/unsubscribe');
          }}
        />
      </div>
    </div>
  );
}

export default NewsletterPage;
